import { useMemo } from 'react';
import { LeaderboardMultiplier } from '@/types/leaderboard.types';
import { ICONS } from '@ui/icons/types';
import Icon from '@ui/icons/icon';
import LeaderboardActionSettingCard from './action-setting';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Container from '@ui/container/container';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import styles from './action-settings.module.css';

interface LeaderboardActionSettingsProps {
  actions: LeaderboardMultiplier[];
  editActions: () => void;
  loadingActions: boolean;
}

const LeaderboardActionSettings: React.FC<LeaderboardActionSettingsProps> = ({
  actions,
  editActions,
  loadingActions,
}) => {
  // boolean for determining if at least one action is enabled
  // used to show empty state if needed
  const hasEnabledActions = useMemo(() => {
    return !!actions.length && !!actions.some((action) => action.is_on === true);
  }, [actions]);

  return (
    <Container borderRadius="12px" className="flex flex-column gap-12">
      <Container className="flex jc-space-between">
        <Text className="H6">Actions</Text>
        <Button hoverOpacity={0.8} disabled={loadingActions} className="clear-button L2" onClick={editActions}>
          {hasEnabledActions && (
            <Text className="flex ai-center gap-6" color={getThemeColorCSSVariable()}>
              <Icon name={ICONS.EDIT_SOLID} size={12} /> Edit actions
            </Text>
          )}
        </Button>
      </Container>
      {hasEnabledActions ? (
        <Container className={`grid gap-8 ${styles.actionsGrid}`}>
          {actions
            .filter((action) => action.is_on)
            ?.map((setting, index) => (
              <LeaderboardActionSettingCard key={`setting-${index}`} setting={setting} />
            ))}
        </Container>
      ) : (
        <Container className="flex ai-center jc-center flex-column gap-8" height="120px">
          <Text className="H5">No rules</Text>
          <Button
            designSize="medium"
            className="margin-t-16"
            backgroundColor={getThemeColorCSSVariable(EColorVariablesV2.primary)}
            onClick={editActions}
          >
            <Text
              className="L1"
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            >
              Add rules
            </Text>
          </Button>
        </Container>
      )}
    </Container>
  );
};

export default LeaderboardActionSettings;
